module.exports = __webpack_public_path__ + "static/media/logo_pont.57a27422.png";